import { useEffect } from "react"
import { useToggle } from "react-use"
import { useParams } from "react-router-dom"

import { HelpTooltip, PaymentWidget, SupportDescription } from "components"
import { usePaymentContext } from "modules/Payment/PaymentContext"
import { ErrorPage } from "modules/Payment/ErrorPage"
import { BookingStatusMap, PaymentSystemType } from "utils/interfaces"
import { SuccessPage } from "modules/Payment/SuccessPage"
import { SESSION_TYPE } from "modules/Booking/common/constants"
import { TryAgain } from "modules/BookingCommon/components"

export function PaymentPage() {
    const { id } = useParams<{ id: string }>()
    const [showError, toggleShowError] = useToggle(false)

    const [{ bookingDetails }, { setBookingStatus }] = usePaymentContext()
    const [rerenderWidget, toggleRenderWidget] = useToggle(true)
    const [showSuccessPayment, toggleShowSuccessPayment] = useToggle(false)

    useEffect(() => {
        toggleRenderWidget(true)
    }, [rerenderWidget])

    useEffect(() => {
        if (showSuccessPayment) {
            setBookingStatus(BookingStatusMap.PAID)
        }
    }, [showSuccessPayment])

    function handleError() {
        toggleShowError(true)
    }

    const tryAgain =
        bookingDetails?.payment_system === PaymentSystemType.CLOUDPAYMENTS ||
        bookingDetails?.payment_system === PaymentSystemType.STRIPE

    if (showSuccessPayment) {
        return <SuccessPage needLoadingDetails />
    }

    if (showError) {
        return (
            <ErrorPage
                headline="Произошла ошибка"
                secondary={
                    <>
                        Попробуйте снова или обратитесь в&nbsp;службу поддержки
                        <span className="booking__error-support-tooltip-image">
                            <HelpTooltip
                                overlay={<SupportDescription lang="ru" className="is-dark" />}
                            />
                        </span>
                    </>
                }
            />
        )
    }

    return (
        <div className="redesign-container">
            {rerenderWidget && id && (
                <PaymentWidget
                    {...bookingDetails}
                    booking_hash={id}
                    onError={handleError}
                    onSuccess={toggleShowSuccessPayment}
                    sessionType={SESSION_TYPE.DEFAULT}
                    psy={PaymentWidget.getPsyData(bookingDetails.psy)}
                />
            )}
            {tryAgain && <TryAgain onClickGoToPayment={toggleRenderWidget} />}
        </div>
    )
}
